import assign from 'lodash/assign';

import { VolusionPaymentsServiceModule } from 'services/data/volusionPayments.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

import template from './volusionPaymentsSignupManagement.html';
import './volusionPaymentsSignupManagement.scss';

export const VolusionPaymentsSignupManagement = angular
    .module('app.components.volusionPaymentsSignupManagement', [
        'ngMaterial',
        VolusionPaymentsServiceModule,
        StoreInformationServiceModule
    ]).component('volusionPaymentsSignupManagement', {
        template,
        controller: class VolusionPaymentsSignupManagementController {
            constructor($scope, $mdDialog, $timeout, volusionPaymentsService, storeInformationService) {
                'ngInject';

                assign(this, {
                    gtmId: 'settings_payment.detail',
                    $mdDialog,
                    $scope,
                    $timeout,
                    volusionPaymentsService,
                    storeInformationService,
                    isLoading: true
                });

                this.closeDialog = this.closeDialog.bind(this);
                this.handleAccountSave = this.handleAccountSave.bind(this);
                this.handleAccountSaveError = this.handleAccountSaveError.bind(this);
            }

            $onInit() {
                this.getStoreInfo();
            }

            getStoreInfo() {
                const force = true;
                this.storeInformationService.getStore(force)
                    .then((storeInfo) => {
                        this.storeInfo = storeInfo;
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        this.storeInfoError = err;
                    });
            }

            shouldShowControls() {
                return !this.isSaving && !this.isDoneSaving && !this.isLoading;
            }

            saveAccountCreated() {
                this.isSaving = true;
                this.volusionPaymentsService.saveAccountCreated()
                    .then(this.handleAccountSave)
                    .catch(this.handleAccountSaveError);
            }

            saveAccountDenied() {
                this.isSaving = true;
                this.volusionPaymentsService.saveAccountDenied()
                    .then(this.handleAccountSave)
                    .catch(this.handleAccountSaveError);
            }

            handleAccountSave() {
                this.isSaving = false;
                this.isDoneSaving = true;
            }

            handleAccountSaveError(error) {
                this.savingError = error;
                this.isSaving = false;
            }

            cancelDialog(result) {
                this.$mdDialog.cancel(result);
            }

            closeDialog(results) {
                if (results) {
                    this.$mdDialog.hide(results);
                } else {
                    this.$mdDialog.hide();
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/volusionPaymentsSignupManagement/volusionPaymentsSignupManagement.component.js